import { RouteConfig } from 'vue-router';

import { Rules as CaslRules } from '../../../back/src/casl/casl.constants';

import AmostrasUtingaIndexProducao from '@/pages/amostras-utinga/AmostrasUtingaIndexProducao.vue';

const routes: RouteConfig[] = [
  {
    path: '/utinga/producao',
    name: 'AmostrasUtingaIndexProducao',
    component: AmostrasUtingaIndexProducao,
    meta: {
      icon: 'mdi-view-list',
      rules: [CaslRules.AmostraUtinga.listarProducao],
    },
  },
];

export default routes;
